/* eslint-disable no-unused-vars */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import queryString from "query-string";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Box, Button as MuiButton } from "@mui/material";
import EmptyFileIcon from "../../../assets/svg/EmptyFile";
import ReloadIcon from "../../../assets/svg/ReloadIcon";
import AppliedFilter from "../../../components/common/AppliedFilter/AppliedFilter";
import Loader from "../../../components/common/Loader/Loader";
import Modal from "../../../components/common/Modal/Modal";
import Pagination from "../../../components/common/new/Pagination/Pagination";
import useUserConfig from "../../../hooks/useUserConfig";
import {
  AppliedFilterLabelMap,
  DATES,
  EVENT_NAME,
  Constants,
  AlertStatus,
} from "../../../contants";
import useQueryParams from "../../../hooks/useQueryParams";
import {
  INITIATE_GOHONZON_TRACKING,
  SET_MEMBER_FOR_TRACKING_GOHONZON,
  SET_SELECTED_MEMBER_TRANSFER,
} from "../../../redux/actionTypes/dashboard";
import {
  selectAllSIUsers,
  selectOSKeysByUserRole,
} from "../../../redux/selectors/user";
import { ROUTES } from "../../../utils/constants";
import { formDataToObject, isEmptyObj } from "../../../utils/helper";
import OrganizationSearchWrapper from "../../member/MemberSearch/OrganizationSearch";
import {
  getFilters,
  getFormattedQuery,
  handleDependencyFilter,
  performOperation,
} from "../../appointment/AppointmentTracking/Utils";
import Styles from "../../member/MemberSearch/MemberSearch.styles";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import PersonalDetailsSearch from "./PersonalDetailsSearch";
import GOhonzonTrackingTable from "./Table";
import Gohonzon from "../../../services/api/gohonzon";
import Button from "../../../components/common/Button";

const LOADER_DELAY = 1000;
const PAGE = "page";
const filterOrder = [
  "areaId",
  "clusterId",
  "zoneId",
  "regionId",
  "chapterId",
  "districtId",
];

function GohonzonTracking() {
  const [searchData, setSearchData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openResultModal, setOpenResultModal] = useState(false);
  const [showSearchResult, setShowSearchResult] = useState(false);
  const allowModalRef = useRef(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  const formRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const metaData = useSelector((state) => state.meta);
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);
  const {
    isHelpDesk,
    isChapterSi,
    isHelpDeskAdmin,
    isAreaSi,
    isClusterSi,
    isZoneSi,
  } = useSelector(selectAllSIUsers);
  const hasPermission = useUserConfig();
  const { getQueryObject, getQueryParams, urlSearchParams } = useQueryParams();
  const [openRoleModal, setOpenRoleModal] = useState(false);
  const [openHDCModal, setOpenHDCModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.DEFAULT_PAGE_SIZE);

  const toast = useContext(ToastAlertContext);

  useEffect(() => {
    const onResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const clearFormRef = () => {
    Object.keys(AppliedFilterLabelMap).forEach((key) => {
      if (formRef.current[key]) {
        formRef.current[key].value = "";
        formRef.current[key]?.blur();
      }
    });
  };

  const resetFormState = () => {
    setSearchData([]);
    setAppliedFilters([]);
    clearFormRef();
  };

  const initializeFormState = (queryObject) => {
    if (!isEmptyObj(queryObject)) {
      clearFormRef();
      Object.keys(queryObject).forEach((key) => {
        if (formRef.current[key]) {
          formRef.current[key].value = queryObject[key];
        }
      });
    }
  };

  const getRoutePath = () => ROUTES.GOHONZON_TRACKING.path;

  const updateSearchParam = (query) => {
    if (query?.length) {
      navigate(`${getRoutePath()}?${query}`);
    } else {
      navigate(`${getRoutePath()}`);
    }
  };

  const removeKeyFromQuery = (queryObject, filterKey) => {
    let updatedQuery = {
      ...queryObject,
      number: 0,
      size: Constants.DEFAULT_PAGE_SIZE,
    };

    if (DATES.includes(filterKey)) {
      delete updatedQuery[filterKey];
      delete updatedQuery[`${filterKey.split("From")[0]}To`];
    } else {
      delete updatedQuery[filterKey];
    }

    if (Object.keys(updatedQuery).length === 1 && PAGE in updatedQuery) {
      delete updatedQuery[PAGE];
    }

    updatedQuery = handleDependencyFilter(updatedQuery, disabledOSKeys);

    return updatedQuery;
  };

  const onRemoveFilter = (filterKey) => {
    let queryObject = getQueryObject();
    queryObject = removeKeyFromQuery(queryObject, filterKey);
    const updatedQuery = queryString.stringify(queryObject);
    updateSearchParam(updatedQuery);
    clearFormRef();
  };

  const validateAndFetchData = (formattedQuery, toast, setIsLoading) => {
    if (
      ((!formattedQuery.hasOwnProperty("applicationFrom") ||
        formattedQuery.dateFrom === "") &&
        !formattedQuery.hasOwnProperty("applicationTo")) ||
      formattedQuery.dateTo === ""
    ) {
      toast.show("Please enter date from Advance Search", AlertStatus.ERROR);
      setIsLoading(false);
      return false;
    }

    return true;
  };

  const fetchSearchData = async (queryParams) => {
    const formattedQuery = getFormattedQuery({
      ...queryParams,
      page: queryParams.number,
      size: queryParams.size,
    });

    dispatch({
      type: INITIATE_GOHONZON_TRACKING,
      payload: formattedQuery,
    });

    try {
      setIsLoading(true);

      if (validateAndFetchData(formattedQuery, toast, setIsLoading)) {
        const { data } = await Gohonzon.gohonzonTracking(formattedQuery);
        setTimeout(() => {
          setSearchData(data.content);
          setCurrentPage(data.number);
          setTotalPages(data.totalPages);
          setTotalElements(data.totalElements);
          setPageSize(pageSize);
          setIsLoading(false);

          if (data.content.length > 0) {
            if (allowModalRef.current) {
              setOpenResultModal(true);
              setShowSearchResult(true);
              allowModalRef.current = false;
            }
          } else {
            toast.show("No data found", AlertStatus.ERROR);
            setOpenResultModal(false);
            setShowSearchResult(false);
            allowModalRef.current = false;
          }
        }, LOADER_DELAY);
      }
    } catch (error) {
      setIsLoading(false);
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
      Sentry.captureException(error);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const rawFormData = new FormData(formRef.current);
    const formData = formDataToObject(rawFormData);
    formData.number = 0;
    formData.size = Constants.DEFAULT_PAGE_SIZE;
    const query = queryString.stringify(formData);

    document.dispatchEvent(new Event(EVENT_NAME));

    allowModalRef.current = true;

    updateSearchParam(query);

    fetchSearchData(formData);
  };

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const [query, params] = getQueryParams(queryObject);
      fetchSearchData(query, params);
      initializeFormState(query);
    } else {
      resetFormState();
      setOpenResultModal(false);
      setShowSearchResult(false);
      allowModalRef.current = false;
    }
  }, [urlSearchParams.toString()]);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const query = getQueryParams(queryObject)[0];
      delete query.number;
      delete query.size;
      setAppliedFilters(getFilters(query, metaData, disabledOSKeys));
    }
  }, [metaData, urlSearchParams.toString()]);

  const onPaginationClick = (clickedNumber) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      number: clickedNumber,
    });
    updateSearchParam(queryParams);
  };

  const onPageSizeClick = (operator) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      number: 0,
      size: queryObject.pageSize
        ? performOperation(
            queryObject.size,
            Constants.DEFAULT_PAGE_SIZE,
            operator
          )
        : 2 * Constants.DEFAULT_PAGE_SIZE,
    });
    updateSearchParam(queryParams);
  };

  const onSelectMemberForTransfer = (member) => {
    dispatch({
      type: SET_SELECTED_MEMBER_TRANSFER,
      payload: member,
    });
    navigate(ROUTES.MEMBER_TRANSFER_REQUEST.path);
  };

  const onMemberSelect = (selectedMember, params = "") => {
    dispatch({
      type: SET_MEMBER_FOR_TRACKING_GOHONZON,
      payload: selectedMember,
    });
    navigate(`/${ROUTES.GOHOZON_SUBMISSION.path}${params ? `/${params}` : ""}`);
  };

  const onRefresh = () => {
    const queryObject = getQueryObject();
    const [query, params] = getQueryParams(queryObject);
    fetchSearchData(query, params);
  };

  const clearAllFilter = () => {
    resetFormState();
    updateSearchParam();
    setShowSearchResult(false);
    setOpenResultModal(false);
    allowModalRef.current = false;
  };

  const handleGoBackToSearch = () => {
    setOpenResultModal(false);
    setShowSearchResult(false);
    allowModalRef.current = false;
  };

  const orderedFilters = filterOrder
    .map((filterKey) =>
      appliedFilters.find((filter) => filter.key === filterKey)
    )
    .filter(Boolean);

  const additionalFilters = appliedFilters.filter(
    (filter) => !filterOrder.includes(filter.key)
  );

  const closeRoleModal = () => {
    setOpenRoleModal(false);
  };

  const closeHDCModal = () => {
    setOpenHDCModal(false);
  };

  return (
    <div style={Styles.container}>
      {/* Clear Filters Button - Top Right */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "1px",
        }}
      >
        <MuiButton
          onClick={clearAllFilter}
          variant="outlined"
          color="secondary"
          sx={{
            textTransform: "none",
            height: "20px",
            fontSize: "13px",
            fontWeight: "600",
            marginRight: "10px",
            width: "85px",
            padding: "0px !important",
          }}
        >
          Clear Filters
        </MuiButton>
      </div>

      {/* Search Form */}
      <div style={Styles.filter}>
        <form
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            width: "100%",
          }}
          onSubmit={onSubmit}
          ref={formRef}
        >
          {/* Organization Structure - Direct */}
          <div>
            <div style={{ fontWeight: "600", marginBottom: "8px" }}>
              Organization Structure
            </div>
            <OrganizationSearchWrapper
              formRef={formRef}
              disabledOSKeys={disabledOSKeys}
            />
          </div>

          {/* Advance Search - Direct */}
          <div>
            <div style={{ fontWeight: "600", marginBottom: "8px" }}>
              Advance Search
            </div>
            <PersonalDetailsSearch
              formRef={formRef}
              disabledOSKeys={disabledOSKeys}
            />
          </div>

          {/* Search Button */}
          <div
            style={{
              alignSelf: "end",
              marginTop: "10px",
              marginRight: "5px",
              marginBottom: isMobile ? "50px" : "0px",
            }}
          >
            <Button label="Search" type="submit" />
          </div>
        </form>
      </div>

      {isLoading && <Loader />}

      {/* Search Results Modal */}
      <Modal
        open={openResultModal}
        onClose={handleGoBackToSearch}
        title="Search Results"
        customStyle={{
          marginTop: "30px",
          width: "98%",
          maxWidth: "100%",
          height: "90%",
          maxHeight: "100%",
          overflowY: "auto",
          backgroundColor: "#fff",
          display: "flex",
          flexDirection: "column",
          padding: "0px 10px 2px 10px",
          position: "relative",
        }}
      >
        {isLoading ? (
          <Loader />
        ) : searchData.length > 0 ? (
          <>
            {/* Modal Header Row */}
            <div
              style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: "10px",
                fontWeight: 600,
                fontSize: 13,
                marginBottom: "0px",
                paddingBottom: "0px",
                borderBottom: "1px solid #eee",
              }}
            >
              {/* Left: Total + Applied Filters */}
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  minWidth: 260,
                  gap: 10,
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <div style={{ flex: "0 0 auto" }}>
                  Total Members: {totalElements}
                </div>
                {appliedFilters.length > 0 && (
                  <div style={{ flex: 1, minWidth: 200 }}>
                    <div style={Styles.filterWrapper}>
                      <div style={Styles.filterContainer}>
                        {orderedFilters.map((filter) => (
                          <AppliedFilter
                            key={filter.key}
                            filter={filter}
                            onRemove={onRemoveFilter}
                          />
                        ))}
                        {additionalFilters.map((filter) => (
                          <AppliedFilter
                            key={filter.key}
                            filter={filter}
                            onRemove={onRemoveFilter}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Right: Reload + Clear + Back */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  flexWrap: "wrap",
                  flex: "0 0 auto",
                }}
              >
                <div style={Styles.reload} onClick={onRefresh}>
                  <ReloadIcon />
                </div>
                <MuiButton
                  onClick={clearAllFilter}
                  variant="outlined"
                  color="secondary"
                  sx={{
                    textTransform: "none",
                    height: "32px",
                    fontSize: "13px",
                    padding: "0 14px",
                    minWidth: "100px",
                  }}
                >
                  Clear Filters
                </MuiButton>
                <MuiButton
                  onClick={handleGoBackToSearch}
                  variant="contained"
                  color="primary"
                  sx={{
                    textTransform: "none",
                    height: "32px",
                    fontSize: "13px",
                    padding: "0 14px",
                  }}
                >
                  Back
                </MuiButton>
              </div>
            </div>

            {/* Table */}
            <div style={{ flex: 1, overflowX: "auto", marginTop: "15px" }}>
              <GOhonzonTrackingTable
                searchData={searchData}
                onSelectMemberForTransfer={onSelectMemberForTransfer}
                onMemberSelect={onMemberSelect}
                hasPermission={hasPermission}
                showStatusColumn={isHelpDesk || isHelpDeskAdmin}
                isChapterSi={isChapterSi}
                isHelpDesk={isHelpDesk}
                isAreaSi={isAreaSi}
                isClusterSi={isClusterSi}
                isZoneSi={isZoneSi}
                isHelpDeskAdmin={isHelpDeskAdmin}
              />
            </div>

            {/* Pagination */}
            <div style={{ marginTop: "20px" }}>
              <Pagination
                totalPages={totalPages}
                totalResults={totalElements}
                currentPage={currentPage}
                pageSize={pageSize}
                onChange={onPaginationClick}
                onPageSizeClick={onPageSizeClick}
              />
            </div>
          </>
        ) : showSearchResult ? null : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "30px 0",
              color: "#777",
            }}
          >
            <EmptyFileIcon width={100} />
            <span style={{ marginTop: "10px" }}>
              No data found with current Filters
            </span>
          </div>
        )}
      </Modal>

      {/* Role Modal */}
      <Modal
        open={openRoleModal}
        onClose={closeRoleModal}
        title="Roles"
        customStyle={{ minWidth: "30%" }}
      />

      {/* HDC Modal */}
      <Modal
        open={openHDCModal}
        onClose={closeHDCModal}
        title="Honorary District Chief"
      />
    </div>
  );
}

export default GohonzonTracking;
